export { default } from './FusePageSimple'
